import { render } from "./indextestimonial.vue?vue&type=template&id=74638465"
import script from "./indextestimonial.vue?vue&type=script&lang=js"
export * from "./indextestimonial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__